import { FC, useCallback } from "react";
import { executeAction, sendVisitorInfo } from "../../store/actions";
import { useChatServerDispatch } from "../../utils/useChatServerDispatch";
import { MessageFormData } from "../MessageForm";
import PrechatForm from "./PrechatForm";
import { useSelector } from "react-redux";
import { ChatState } from "../../store/ChatState";

export interface PrechatFormContainerProps {
    readonly time?: string;
}

const PrechatFormContainer: FC<PrechatFormContainerProps> = (props) => {
    const dispatch = useChatServerDispatch();
    const sessionId = useSelector<ChatState, string>((state) => state.sessionId);

    const handleSubmit = useCallback(
        (data: MessageFormData) => {
            // Don't send empty messages
            if (!data.message) return;

            dispatch(
                sendVisitorInfo(
                    {
                        displayName: data.name,
                        email: data.email,
                    },
                    sessionId
                )
            );

            dispatch(executeAction(data.message));
        },
        [dispatch, sessionId]
    );

    return (
        <>
            <span className="message-sr-only">{"at " + props.time + " system message"}</span>
            <PrechatForm onSubmit={handleSubmit} />
        </>
    );
};

export default PrechatFormContainer;
